import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgRedux} from '@angular-redux3/store';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';

import {AFetchRemotes, AFetchResorts, ALogout, ASetPlayerId, ASetResort, PlaylistRemoteAppState, sseApi} from '../../store';
import {Remote, Resort} from '../../store/entities';
import {environment} from '../../../environments/environment';
import {LibraryService} from '../library/library.service';

@Component({
  selector: 'mwo-zone-selection',
  templateUrl: './zone-selection.component.html',
  styleUrls: ['./zone-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})


export class ZoneSelectionPage implements OnInit {
  resorts$: Observable<Array<{ id: string; name: string }>>;
  remotes$: Observable<Array<{ id: string; name: string }>>;
  resort: Observable<Resort>;


  @Input() isSidePanel: boolean;
  @Input() showMenu: boolean;
  @Output() changePlayer: EventEmitter<Remote> = new EventEmitter<Remote>();

  singleResort;
  singleRemote;
  resortSelected: Resort;
  backgroundImage: string;
  showSearchInput = false;
  search = '';
  private moved = false;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private router: Router,
    private libraryService: LibraryService
  ) {
    this.resorts$ = ngRedux.select('resorts');
    this.remotes$ = ngRedux.select('remotes');
    this.resort = ngRedux.select('resort');
  }


  ngOnInit() {
    if (environment.enableDesktopMode) {
      this.checkMoved();
    }
    this.backgroundImage = localStorage.getItem('bgUrl');
    this.ngRedux.dispatch(AFetchResorts());
    this.resort.subscribe(resort => {
      if (this.isSidePanel) {
        this.resortSelected = resort;
      }
    });
    this.checkResortsSkip();
    this.checkRemotesSkip();
  }

  private checkMoved() {
    setTimeout(() => {
      if (!this.moved) {
        this.resorts$.subscribe(resorts => {
          if (!resorts || !resorts.length) {
            this.ngRedux.dispatch(AFetchResorts());
          } else {
            this.ngRedux.dispatch(ASetResort(resorts[0]));
          }
        });
        this.router.navigate(['/library']).then((moved) => {
          this.moved = moved;
        });
        this.checkMoved();
      }
    }, 5000);
  }

  onResortSelected(resort: Resort) {
    this.search = '';
    this.showSearchInput = false;
    this.ngRedux.dispatch(ASetResort(resort));
    this.ngRedux.dispatch(AFetchRemotes(resort.id));
    this.resortSelected = resort;
  }

  onRemoteSelected(remote: Remote) {
    this.search = '';
    this.showSearchInput = false;
    this.libraryService.setLastPlayerId('');
    if (this.isSidePanel && !environment.enableDesktopMode) {
      sseApi.close();
      this.changePlayer.emit(remote);
    } else {
      this.ngRedux.dispatch(ASetPlayerId(remote));
      this.router.navigate(['/library']).then((moved) => {
        this.moved = moved;
      });
    }
  }

  handleClickLogout() {
    this.ngRedux.dispatch(ALogout());
  }

  back() {
    this.search = '';
    this.showSearchInput = false;
    this.resortSelected = undefined;
  }

  toggleSearchInput() {
    this.search = '';
    this.showSearchInput = !this.showSearchInput;
  }

  private checkResortsSkip() {
    this.resorts$
      .subscribe(resorts => {
        if (resorts.length === 1) {
          this.singleResort = resorts[0];
          this.onResortSelected(this.singleResort);
        }
      });
  }

  private checkRemotesSkip() {
    if (!this.isSidePanel) {
      this.remotes$
        .subscribe(remotes => {
          if (remotes.length === 1) {
            this.singleRemote = remotes[0];
            this.onRemoteSelected(this.singleRemote);
          }
        });
    }
  }
}
